import React from 'react';
import ErrorPageNotFound from '../../components/errors/error-404';

const Error404Page = () => {
  return <ErrorPageNotFound />;
};

export default Error404Page;
